var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Home" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      Scan QR code\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "list-item" }, [
      _c(
        "div",
        {
          staticClass:
            "pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center "
        },
        [
          _c("qrcode-reader", {
            staticClass: "qrcode",
            on: { decode: _vm.onDecode }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9212b74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9212b74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/ScanToSearch.vue
// module id = 408
// module chunks = 1